import i18next from "i18next";

export const createIndexDB = (token = null) => {
  const request = indexedDB.open('my-database', 1);

  request.onupgradeneeded = event => {
    const db = event.target.result;
    if (!db.objectStoreNames.contains('my-store')) {
      db.createObjectStore('my-store', { keyPath: 'id' });
  }
  };

  request.onsuccess = event => {
    console.log('indexDB created Successfully');
    const db = event.target.result;
    const transaction = db.transaction('my-store', 'readwrite');
    const store = transaction.objectStore('my-store');
    const language = i18next?.language ? i18next.language : process.env.REACT_APP_DEFAULT_LOCALE;
    const locale = language.replace(/-/g, "_");
    store.put({ id: 1, data: `${process.env.REACT_APP_BACKEND}api/notifications` });
    store.put({ id: 2, data: token });
    store.put({ id: 3, data: locale });
  };
};
